import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import NotFound from "../../assets/notfound.svg";
import {
  GetFavoriteSpeakers,
  RemoveFavoriteSpeakers,
} from "../../redux/actions/SpeakersAction";
import Loder from "../../components/loder";
import { initGA, initPixel } from "../../helpers/CampaignEvents";
import {MyVerticallyCenteredModal} from "../SpeakerProfileModal";
const FavoriteSpeakers = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [loader, setLoader] = useState(null);

  useEffect(() => {
    initPixel()
    initGA()
    dispatch(GetFavoriteSpeakers());
  }, []);

  const FavoriteSpeakers = useSelector(
    (state) => state.UserReducer.favoriteSpeakers
  );

  const removeFavSpeaker = (id) => {
    const data = {
      speakerId: id,
    };
    const onSuccess = (msg) => {
      openSnackbar(msg);
      setLoader(null);
    };
    const onError = (msg) => {
      openSnackbar(msg);
      setLoader(null);
    };
    dispatch(RemoveFavoriteSpeakers(data, onSuccess, onError));
  };

  return (
    <div className="favorite_speakers mt-3 mt-md-0">
      <hr className="line mx-auto"></hr>

      <div className=" container pt-md-2">
        <div className="card mx-auto ">
          <button className="back-button mb-2" onClick={() => history.goBack()}>
            <i className="fas fa-chevron-left mr-2"></i> Back
          </button>

          <div className="row">
            {FavoriteSpeakers ? (
              FavoriteSpeakers.length > 0 ? (
                FavoriteSpeakers.map((data, i) => (
                  <div className="col-md-3 m-0 col-6" key={data._id}>
                    <div className="tutor_card text-center">
                      <div className="tutor_img_container mb-2">
                        <img
                          className="tutor_img"
                          src={data?.image}
                          alt={data?.name}
                        />
                        {loader === i ? (
                          <>
                            <button className="favorite-btn">
                              <i className="fa fa-spinner fa-spin"></i>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="favorite-btn"
                              onClick={() => {
                                removeFavSpeaker(data?._id);
                                setLoader(i);
                              }}
                            >
                              <i className="fas fa-heart"></i>
                            </button>
                          </>
                        )}
                      </div>
                      {/* <Link
                        to={`/speaker-profiles/${data?._id}`}
                        className="tutor-name"
                      > */}
                      {/* {data?.name} */}
                      {/* </Link> */}
                      <MyVerticallyCenteredModal
                        // show={modalShow}
                        id={data._id} attributeOnClick={data?.name}
                      // onHide={() => setModalShow(false)}

                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className="not_found d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={NotFound}
                    className="not_found_img"
                    alt="Not found"
                  />
                  <h4>
                    Your Favorite speaker list is empty !
                    <span onClick={() => history.goBack()}> Back</span>
                  </h4>
                </div>
              )
            ) : (
              <div className="col-md-12 mt-5 mb-5">
                <Loder message="Fetching favorite teachers ..." />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavoriteSpeakers;
